module.exports = "/../../dist/frontend/images/R-DAM_1385365.webp?0293b4cbedb303ffff9187a9f5900709";